export default function IconArrowRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68306 6.43306C7.92714 6.18898 8.32286 6.18898 8.56694 6.43306L11.6919 9.55806C11.936 9.80214 11.936 10.1979 11.6919 10.4419L8.56694 13.5669C8.32286 13.811 7.92714 13.811 7.68306 13.5669C7.43898 13.3229 7.43898 12.9271 7.68306 12.6831L10.3661 10L7.68306 7.31694C7.43898 7.07286 7.43898 6.67714 7.68306 6.43306Z"
        fill="#1C1C1C"
      />
    </svg>
  );
}
